class TaskModel{
    constructor(task,done){
        this.task=task;
        this.done=done;
    }
}

export default TaskModel;